import * as routes from '../enums/routes'

export default {
  /**
   * Detects #! and removes it from the url
   * @param hash
   * @param router
   * @returns boolean
   */
  ClassLabHashUtil(hash, router) {
    if (hash.includes('#!/share/')) {
      if (hash.includes('?dl=1')) {
        let url = hash.substring(2) + '&src=notebook'
        router.replace(url)
        return true
      } else {
        let url = hash.substring(2) + '?src=notebook'
        router.replace(url)
        return true
      }
    }
    return false
  },
  /**
   * Detects legacy urls and routes them to the correct pages on SMEX 2
   * @param location
   * @param router
   */
  legacyUrlUtil(location, router) {
    switch (location.pathname) {
      case routes.LEGACY_PATHNAME_DETAILS:
        let url = routes.ROUTE_PATH_DETAILS_ERROR
        let id = this.paramHandler('id', location.search)
        router.replace({ path: `${url}?id=${id}` })
        break
      case routes.LEGACY_PATHNAME_TERMS:
        router.replace({ path: routes.HOME })
        break
      case routes.LEGACY_PATHNAME_TRAINING:
        router.replace({ path: routes.HOME })
        break
      case routes.LEGACY_PATHNAME_CURRICULUM:
        router.replace({ path: routes.HOME })
        break
      case routes.LEGACY_PATHNAME_SHARE:
        router.replace({ path: routes.HOME })
        break
      case routes.LEGACY_PATHNAME_SEARCH:
        router.replace({ path: routes.HOME })
        break
      case routes.LEGACY_PATHNAME_INDEX:
        router.replace({ path: routes.HOME })
        break
      case routes.LEGACY_PATHNAME_LOGIN:
        router.replace({ path: routes.HOME })
        break
      case routes.LEGACY_PATHNAME_REGISTER:
        router.replace({ path: routes.HOME })
        break
    }
  },
  /**
   * Handles SMEX specific routing outside of VUE Router
   * @param location
   * @param router
   */
  handleUrlRouting(location, router) {
    this.ClassLabHashUtil(location.hash, router)
    this.legacyUrlUtil(location, router)
  },
  /**
   * Handles route query params
   * @param name
   * @param value
   * @returns string
   */
  paramHandler(name, value) {
    if (value.includes(name)) {
      let index = value.indexOf('=')
      return value.substring(index + 1)
    }
    return ''
  }
}
